import { Helper } from '../Helper';
export class RawIteratorSomeBaseHelper extends Helper {
    constructor(options) {
        super();
        this.each = options.each;
    }
    emit(sb, node, optionsIn) {
        const options = sb.pushValueOptions(optionsIn);
        sb.emitPushBoolean(node, false);
        sb.emitHelper(node, options, sb.helpers.forLoop({
            condition: () => {
                sb.emitOp(node, 'SWAP');
                sb.emitOp(node, 'TUCK');
                sb.emitOp(node, 'OVER');
                sb.emitOp(node, 'NOT');
                sb.emitOp(node, 'SWAP');
                sb.emitSysCall(node, 'Neo.Enumerator.Next');
                sb.emitOp(node, 'BOOLAND');
            },
            each: (innerOptions) => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DUP');
                this.each(sb.pushValueOptions(innerOptions));
            },
            handleReturn: () => {
                sb.emitOp(node, 'DROP');
                sb.emitOp(node, 'DROP');
            },
            cleanup: () => {
                sb.emitOp(node, 'NIP');
                if (!optionsIn.pushValue) {
                    sb.emitOp(node, 'DROP');
                }
            },
        }));
    }
}

//# sourceMappingURL=RawIteratorSomeBaseHelper.js.map
